
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "cancelSubscription",
      resolverType: "mutation",
      routePath: "/cancelSubscription",
      httpMethod: "POST",
    });
  